import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const StyledHamburgerIcon = styled.svg`
    background: none;
    border: none;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;

    @media (max-width: ${BreakPoints.TABLET}) {
        display: flex;
    }
`;
